import '.b0{max-width:1280px;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.db{gap:144px;}.ssr-plugin'
import '.bf{max-width:568px;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.b9{margin-bottom:48px;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { LinkNotes } from './LinkNotes.js'
import { useEffect } from 'react'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'

export const Imprint = () => {
  const track = useTrack('imprint')

  const [lang] = useLanguage()
  const { legalGroupTitle, imprint, moreInfoReachOut } = useDictionary()

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <Layout>
      <styled.div className="b0 ak o v a am db"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bf"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="b3">{legalGroupTitle}</h3>
          <h2 className="b9" style={{ color: colors.primary,}}>
            {imprint}
          </h2>
          <p className="cr">{moreInfoReachOut}</p>
          <LinkNotes />
        </styled.div>
        {/* column 2 */}
        <styled.div className="ca bf"
          dir="ltr"
          style={{
            '& p': {
              // @ts-ignore
              textAlign: 'left !important',
              margin: '1em 0em',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <p>
            Once Germany GmbH
            <br />
            Schanzenstraße 38
            <br />
            51063 Cologne
            <br />
            Germany
          </p>

          <p>
            T: +49 (221) 59 68-88 00
            <br />
            E: info@esc.vote
            <br />
            W: www.once.net
          </p>

          <p>
            Handelsregister Köln | HRB 55372
            <br />
            Tax ID: 218/5728/3147 | VAT ID: DE243135863
            <br />
            Directors: Thomas Niedermeyer & Sebastian Winzen
          </p>
        </styled.div>
      </styled.div>
    </Layout>
  )
}
